import styled from '@emotion/styled'

export const PanelContent = styled.div`
  border-radius: 0 0 4px 4px;
  justify-content: center;
  min-width: 100%;
`

export const PanelContentWrapper = styled.div`
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 0 24px 24px 24px;
`

export const PanelWrapper = styled.div<{ isOpen: boolean }>`
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  position: fixed;
  z-index: 102;
  right: 0;
  height: 100%;
  overflow: scroll;
  // width: ${({ isOpen }) => (isOpen ? 0 : 'auto')};
  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  // visibility: ${({ isOpen }) => !isOpen || 'hidden'};
  /* \${themeMediaQuery('small')} { */
  /*   width: 90%; */
  /* } */
  /* \${themeMediaQuery('medium')} { */
  /*   width: 600px; */
  /* } */
  /* \${themeMediaQuery('large')} { */
  /*   width: 700px; */
  /* } */
`

export const Backdrop = styled.div<{ isOpen: boolean }>`
  background: rgba(255, 255, 255, 0.5);
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  height: 100%;
  justify-content: center;
  left: 0;
  margin: 0;
  padding: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 101;
`
